/* ==========================================================================
   KINOVA — 22-bosqich: RASM NISBATI VA FOKUS (media-fit)

   MUAMMO (foydalanuvchi skrinshotlari, 03.10.2026):
     • Bosh sahifa hero'sida aktyorlarning BOSHLARI kesilib ketardi;
     • kino sahifasi va tomosha oynasidagi poster/fon rasmi qirqilardi.

   SABAB: barcha rasmlar `object-fit: cover` + markaz bilan chiqarilardi.
   `cover` rasmning nisbati ramkaning nisbatiga mos kelmasa, rasmning bir
   qismini JIMGINA kesib tashlaydi — administrator qanday nisbatdagi rasm
   yuklashini oldindan bilib bo'lmaydi (16:9, 3:2, 4:3, kvadrat, 21:9 ...).

   YECHIM — har bir rasm YUKLANGANDA haqiqiy o'lchami o'qiladi va ramka
   bilan solishtiriladi:

     • Qirqim kichik bo'lsa  → `cover`, lekin fokus tepaga/yuzlar tomonga
       siljitilgan (markaziy emas) — boshlar kesilmaydi;
     • Qirqim katta bo'lsa   → `contain`: rasm BUTUN ko'rinadi, atrofi esa
       o'sha rasmning o'zidan yasalgan xira "to'ldirgich" bilan to'ladi
       (hech qanday cho'zilish yoki bo'sh qora joy yo'q).

   Natija `data-fit="cover|contain"` atributi va `--bd-url` o'zgaruvchisi
   sifatida beriladi; ko'rinish `patches.css` (22-bosqich) da.

   QO'SHIMCHA:
     • Rasm fayli topilmasa (404) — "buzilgan rasm" belgisi chiqmaydi:
       `has-image` olib tashlanadi va avvalgi CSS-art ko'rinadi;
     • Administrator belgilagan FOKUS NUQTASI (`data-focus="x,y"`) bo'lsa
       — avtomatik hisob o'rniga o'sha ishlatiladi.

   ⚠️ Faqat HAQIQIY rasm bor elementlarga tegadi (`.has-image`). Rasmsiz
      (CSS-art) holat — va unga asoslangan vizual regressiya — o'zgarmaydi.
   ========================================================================== */
(function () {
  'use strict';

  /* Cover rejimida yo'qotilishi mumkin bo'lgan eng katta ulush.
     Tik o'qda (bosh/yuz qirqiladi) qattiqroq, yon tomonlarda yumshoqroq. */
  var MAX_LOSS_VERTICAL = 0.20;
  var MAX_LOSS_HORIZONTAL = 0.22;
  var MAX_LOSS_POSTER = 0.14;

  var HOSTS = [
    { img: 'backdrop-art__img', host: 'backdrop-art', kind: 'backdrop' },
    { img: 'poster-art__img', host: 'poster-art', kind: 'poster' },
    { img: 'player-splash__art', host: 'player-overlay', kind: 'splash' },
  ];

  function kindOf(img) {
    for (var i = 0; i < HOSTS.length; i++) {
      if (img.classList.contains(HOSTS[i].img)) return HOSTS[i];
    }
    return null;
  }

  function hostOf(img, spec) {
    return img.closest ? img.closest('.' + spec.host) : null;
  }

  /* Fokus: "x,y" (0–100). Noto'g'ri qiymat → null (avtomatik). */
  function parseFocus(raw) {
    if (!raw) return null;
    var m = String(raw).match(/^\s*(\d{1,3}(?:\.\d+)?)\s*[, ]\s*(\d{1,3}(?:\.\d+)?)\s*$/);
    if (!m) return null;
    var x = Math.max(0, Math.min(100, parseFloat(m[1])));
    var y = Math.max(0, Math.min(100, parseFloat(m[2])));
    return { x: x, y: y };
  }

  function apply(img) {
    var spec = kindOf(img);
    if (!spec) return;
    var host = hostOf(img, spec);
    if (!host || !img.naturalWidth || !img.naturalHeight) return;

    var rect = host.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return; // yashirin (hali o'lchanmagan) — keyin qayta uriniladi

    var ir = img.naturalWidth / img.naturalHeight;
    var fr = rect.width / rect.height;
    var loss, vertical, tol;

    if (ir > fr) {          // rasm ramkadan KENGROQ → yon tomonlar qirqiladi
      loss = 1 - fr / ir; vertical = false;
    } else {                // rasm ramkadan TIKROQ → tepa/past qirqiladi
      loss = 1 - ir / fr; vertical = true;
    }
    tol = spec.kind === 'poster' ? MAX_LOSS_POSTER : (vertical ? MAX_LOSS_VERTICAL : MAX_LOSS_HORIZONTAL);

    var mode = loss <= tol ? 'cover' : 'contain';

    if (host.getAttribute('data-fit') !== mode) host.setAttribute('data-fit', mode);

    /* Fokus nuqtasi: administrator belgilagan bo'lsa shu; aks holda
       odatiy (yuzlar odatda yuqori uchdan birda → tepaga yaqin). */
    var focus = parseFocus(img.getAttribute('data-focus'));
    var fx = focus ? focus.x : 50;
    var fy = focus ? focus.y : (spec.kind === 'poster' ? 30 : 22);
    img.style.setProperty('--focus-x', fx + '%');
    img.style.setProperty('--focus-y', fy + '%');

    if (mode === 'contain') {
      var src = img.currentSrc || img.src;
      if (src && host.style.getPropertyValue('--bd-url') !== 'url("' + src + '")') {
        host.style.setProperty('--bd-url', 'url("' + src.replace(/"/g, '%22') + '")');
      }
      feather(img, rect, ir, fr, spec.kind === 'poster' ? 0.08 : 0.14);
    } else {
      unfeather(img);
    }
  }

  /* contain rejimida rasm chegarasi xira to'ldirgichga SILLIQ o'tishi uchun
     (qattiq to'rtburchak chekka ko'rinmasin) rasmning chetlariga niqob beriladi.
     Chekka joyi `object-position` (o'ng yoki markaz) va nisbatdan hisoblanadi. */
  function posPct(v, dflt) {
    if (v === 'left' || v === 'top') return 0;
    if (v === 'right' || v === 'bottom') return 100;
    if (v === 'center') return 50;
    var n = parseFloat(v);
    return isNaN(n) ? dflt : n;
  }
  function feather(img, rect, ir, fr, amount) {
    var cs = window.getComputedStyle(img).objectPosition.split(/\s+/);
    var px = posPct(cs[0], 50), py = posPct(cs[1] || cs[0], 50);
    var drawW, drawH;
    if (ir > fr) { drawW = rect.width; drawH = rect.width / ir; }
    else { drawH = rect.height; drawW = rect.height * ir; }
    var x0 = (rect.width - drawW) * px / 100 / rect.width * 100;
    var x1 = x0 + drawW / rect.width * 100;
    var y0 = (rect.height - drawH) * py / 100 / rect.height * 100;
    var y1 = y0 + drawH / rect.height * 100;
    var fx = (x1 - x0) * amount, fy = (y1 - y0) * amount;

    function axis(dir, a0, a1, f) {
      var left = a0 > 0.5, right = a1 < 99.5;
      if (!left && !right) return null;
      var st = [];
      st.push(left ? 'transparent ' + a0.toFixed(2) + '%' : '#000 0%');
      if (left) st.push('#000 ' + (a0 + f).toFixed(2) + '%');
      if (right) st.push('#000 ' + (a1 - f).toFixed(2) + '%');
      st.push(right ? 'transparent ' + a1.toFixed(2) + '%' : '#000 100%');
      return 'linear-gradient(' + dir + ', ' + st.join(', ') + ')';
    }
    var parts = [axis('90deg', x0, x1, fx), axis('180deg', y0, y1, fy)].filter(Boolean);
    if (!parts.length) { unfeather(img); return; }
    var mask = parts.join(', ');
    img.style.setProperty('-webkit-mask-image', mask);
    img.style.setProperty('mask-image', mask);
    if (parts.length > 1) {
      img.style.setProperty('-webkit-mask-composite', 'source-in');
      img.style.setProperty('mask-composite', 'intersect');
    } else {
      img.style.removeProperty('-webkit-mask-composite');
      img.style.removeProperty('mask-composite');
    }
  }
  function unfeather(img) {
    img.style.removeProperty('-webkit-mask-image');
    img.style.removeProperty('mask-image');
    img.style.removeProperty('-webkit-mask-composite');
    img.style.removeProperty('mask-composite');
  }

  function fail(img) {
    var spec = kindOf(img);
    if (!spec) return;
    var host = hostOf(img, spec);
    /* Fayl yo'q / buzilgan: rasm elementini olib tashlaymiz, CSS-art qaytadi. */
    if (host) {
      host.classList.remove('has-image');
      host.removeAttribute('data-fit');
    }
    if (img.parentNode) img.parentNode.removeChild(img);
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('.backdrop-art__img, .poster-art__img, .player-splash__art');
    for (var i = 0; i < list.length; i++) {
      var img = list[i];
      if (img.complete) {
        if (img.naturalWidth) apply(img); else fail(img);
      }
    }
  }

  /* `load`/`error` hodisalari ko'tarilmaydi — capture bosqichida ushlaymiz. */
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') apply(t);
  }, true);
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') fail(t);
  }, true);

  /* Ramka o'lchami o'zgarganda (burilish, oyna o'lchami, hero balandligi)
     rejim qayta hisoblanadi. */
  var pending = false;
  function rescan() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(function () { pending = false; scan(); });
  }
  window.addEventListener('resize', rescan, { passive: true });
  window.addEventListener('orientationchange', rescan, { passive: true });

  /* JS bilan keyin qo'shiladigan elementlar (qatorlar, hero karuseli). */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { rescan(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function scanAll() { scan(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanAll);
  else scanAll();
  window.addEventListener('load', scanAll);

  window.KMediaFit = { rescan: rescan, apply: apply };
})();
